function isValidSCAddress(address, currency, networkType) {
    const regex = /^[0-9a-f]{76}$/g; // 76 hex chars
    return address.search(regex) !== -1;
}

export default {
    isValidAddress(address, currency, networkType) {
        return isValidSCAddress(address, currency, networkType);
    },
};
